// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"b73e0d1d","704":"4674e359"}[chunkId] + ".chunk.js";
};